import React, { useEffect } from "react";
import { useSelector, useDispatch,shallowEqual } from "react-redux";
import { withStyles } from "@mui/styles";
import { USER_LOGGED_IN,APPLICATION_INITIALIZED } from "@utils/Events/constants";
import { useStyles } from "./styles";

const widgetState = { fw: false,fc:false };
const initFreshWidget=(forceInit=false,cb)=>{
	if(!window.FreshWidget) return
	(!widgetState.fw || forceInit) &&  FreshWidget.init("", {
                "queryString": "&widgetType=popup",
                "utf8": "✓",
                "widgetType": "popup",
                "buttonType": "image",
                "backgroundImage": "https://drpsdfsopx5b0.cloudfront.net/web/icons/support-widget-icon.png",
                "buttonText": "Support",
                "buttonColor": "white",
                "buttonBg": "#006063",
                "alignment": "3",
                "offset": `${window.innerWidth-50}px`,
                "formHeight": "500px",
                "url": "https://support.leadingreach.com"
            });
	console.log('FreshWidget init',forceInit,!!FreshWidget.iframe());
	widgetState.fw = !!FreshWidget.iframe();	
	cb && cb();	
}	
const hideFreshWidgetBtn=(reInitWidget=3)=>{	
	const fwbtn = document.getElementById("freshwidget-button");
	fwbtn && (fwbtn.style.left="-100px");
	!fwbtn && reInitWidget> 0 && initFreshWidget(true,()=>hideFreshWidgetBtn(reInitWidget-1));
}
const showFreshWidgetBtn=(reInitWidget=3)=>{	
	const fwbtn = document.getElementById("freshwidget-button");
	fwbtn && (fwbtn.style.left=`${window.innerWidth-50}px`);
	!fwbtn && reInitWidget> 0 && initFreshWidget(true,()=>showFreshWidgetBtn(reInitWidget-1));
}	
const initFreshChat=()=>{
	!widgetState.fc && window.fcWidget && fcWidget.init({
		token:"b575051a-edd3-43a5-8343-d38cb5f2b12f",
		host: "https://wchat.freshchat.com",
        config: {
            headerProperty: {
                hideChatButton: true
            }
        }
	});
	widgetState.fc = !!window.fcWidget;	
	hideFreshWidgetBtn();	
}	
initFreshWidget();		
const Footer = React.memo(({ classes,footerClass,...opts} ) => {
	const { isLoggedIn } = useSelector(state => state.userReducer, shallowEqual);
	const [state,setState] = React.useState({chatWidgetEnabled:widgetState.fc,open:false});
	const updateState = (newState)=>setState(prevState=>({...prevState,...newState}));
	const toggleChatWidget = (e)=>{
		e?.preventDefault();
		updateState({open:!state.open});
	}
	const showFreshWidget = (e)=>{
		e?.preventDefault();
		initFreshWidget();	
		FreshWidget.show();
		updateState({open:false});
	}	
	
	
	const showChatWidget = (e)=>{
		e?.preventDefault();
		fcWidget.open();
		updateState({open:false});
	}	

	useEffect(()=>{
		const onUserLoggedIn = ()=>{
			//console.log("Footer:USER_LOGGED_IN",_app.u);
			initFreshChat();
			updateState({chatWidgetEnabled:true,open:false});
		}
		initFreshWidget(false,()=>{
			widgetState.fw && !isLoggedIn && showFreshWidgetBtn(0);
			isLoggedIn && widgetState.fw && window.fcWidget && fcWidget.isInitialized() && hideFreshWidgetBtn(0);
		});
		const sub = _app.events.subscribe({[USER_LOGGED_IN]: onUserLoggedIn,[APPLICATION_INITIALIZED]: onUserLoggedIn});
		return ()=>{
			_app.events.unsubscribe(sub);
		}
	})
	useEffect(() => {
		//isLoggedIn && console.log("showFreshWidgetBtn>>");
		if(state.chatWidgetEnabled && !isLoggedIn){
			//console.log("showFreshWidgetBtn");
			updateState({chatWidgetEnabled:false,open:false});
			window.fcWidget && fcWidget.isInitialized() && fcWidget.isInitialized() && fcWidget.destroy();
			widgetState.fc = false;
			showFreshWidgetBtn();
		}
	}, [isLoggedIn])
	return (<>
		<div className={`${classes.footerContainer} page-footer ${footerClass || ''}`}>
			{/* <VersionDetail /> */}
			<p className={classes.footerDescription}>
				<a class="lr-link" href="https://leadingreach.com/terms-service" target="_blank">Terms of Service</a> 
				&nbsp;·&nbsp;
                <a class="lr-link" href="https://leadingreach.com/privacy-policy" target="_blank">Privacy Policy</a> 
				&nbsp;·&nbsp;LeadingReach is a trademark of Leading Reach, Inc. © {new Date().getFullYear()} All rights reserved.
				{/* <br/>
				Having trouble? Contact us 
				&nbsp;<a class="lr-link" onClick={showFreshWidget} href="#">here</a>,
				or check out our online
				&nbsp;<a class="lr-link" target="_blank" href="https://support.leadingreach.com">HelpDesk</a>. */}
			</p>
			{/* <div class="freshwidget-button fd-btn-bottom" style={{right: 50}}>
				<a href="javascript:void(0)" class="freshwidget-customimage">
					<img src="https://drpsdfsopx5b0.cloudfront.net/web/icons/support-widget-icon.png" alt="Support"/>
				</a>
			</div> */}
		</div>
		{state.chatWidgetEnabled && <div className={classes.chatWidget}>
			<div className="footer-support-text">
				SUPPORT
			</div>

			<div class="freshdesk-help-icon toggle-support-widgets" onClick={toggleChatWidget}>
				<img src={`/static/images/support-${state.open ? "close" : "open"}.svg`}/>
			</div>
    
			{state.open && <div className="help-popup">

				<div class="help-panel help-chat" onClick={showChatWidget}>
					<div class="panel">
						<div class="panel-body">
							<h5>Chat Live</h5>
							<p>We're here to help with your questions or issues. Ask away!</p>
						</div>
					</div>
					<div class="freshdesk-help-icon">
						<img src="/static/images/chat.svg"/>
					</div>
				</div>

				<div class="help-panel help-desk" onClick={showFreshWidget}>
					<div class="panel">
						<div class="panel-body">
							<h5>Help Desk</h5>
							<p>Submit a help request or search our knowledge base.</p>
						</div>
					</div>
					<div class="freshdesk-help-icon">
						<img src="/static/images/help-desk.svg"/>
					</div>
				</div>

			</div>}
		</div>}
</>
	)
})

export default withStyles(useStyles)(Footer);
